/* yy-countdown.js - contador regressivo Dia(s) : Hora(s) : Min(s) : Seg(s), sempre no horário de Brasília.
   Preenche todo bloco [data-yy-cd] da página (aviso do topo, barra da página do produto, quickview).
   Sem data de término (data-end vazio): conta até a meia-noite e recomeça todo dia às 00:00.
   Com data de término (data-end="DD/MM/AAAA"): conta até 23:59:59 desse dia; depois o bloco recebe a classe yy-cd--ended. */
(function () {
  if (window.__yyCountdown) return;
  window.__yyCountdown = true;

  var OFFSET = -3 * 3600000; /* Brasília: UTC-3, sem horário de verão */
  var DAY = 86400000;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* fim da promoção: 00:00 de Brasília do dia seguinte à data informada (DD/MM/AAAA) */
  function endTime(str) {
    var m = /^\s*(\d{1,2})\/(\d{1,2})\/(\d{4})\s*$/.exec(str || '');
    if (!m) return null;
    var d = +m[1], mo = +m[2], y = +m[3];
    var t = Date.UTC(y, mo - 1, d, 0, 0, 0, 0);
    var chk = new Date(t);
    if (chk.getUTCFullYear() !== y || chk.getUTCMonth() !== mo - 1 || chk.getUTCDate() !== d) return null;
    return t + DAY - OFFSET;
  }

  function setNum(box, key, value) {
    var el = box.querySelector('[data-yy-' + key + ']');
    if (el && el.textContent !== value) el.textContent = value;
  }

  function tick() {
    var now = Date.now();
    var boxes = document.querySelectorAll('[data-yy-cd]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var end = endTime(box.getAttribute('data-end'));
      var ended = end !== null && now >= end;
      box.classList.toggle('yy-cd--ended', ended);
      if (ended) continue;
      var s;
      if (end !== null) {
        s = Math.ceil((end - now) / 1000);
      } else {
        var elapsed = (((now + OFFSET) % DAY) + DAY) % DAY;
        s = Math.min(86399, Math.ceil((DAY - elapsed) / 1000));
      }
      setNum(box, 'd', pad(Math.floor(s / 86400)));
      setNum(box, 'h', pad(Math.floor(s % 86400 / 3600)));
      setNum(box, 'm', pad(Math.floor(s % 3600 / 60)));
      setNum(box, 's', pad(s % 60));
    }
  }

  function loop() {
    tick();
    setTimeout(loop, 1000 - (Date.now() % 1000) + 5);
  }

  tick();
  loop();
  document.addEventListener('DOMContentLoaded', tick);
  document.addEventListener('shopify:section:load', tick);

  /* conteúdo que chega depois (quickview, carrinho lateral): preenche na hora, sem esperar o próximo segundo */
  function watch() {
    var timer = null;
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        if (m[i].addedNodes.length) {
          if (!timer) timer = setTimeout(function () { timer = null; tick(); }, 30);
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();
